import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'callouts',
    label: 'Callouts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
